/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeaderboardEndIntent } from './LeaderboardEndIntent';
import {
    LeaderboardEndIntentFromJSON,
    LeaderboardEndIntentFromJSONTyped,
    LeaderboardEndIntentToJSON,
    LeaderboardEndIntentToJSONTyped,
} from './LeaderboardEndIntent';
import type { ResetTimingMode } from './ResetTimingMode';
import {
    ResetTimingModeFromJSON,
    ResetTimingModeFromJSONTyped,
    ResetTimingModeToJSON,
    ResetTimingModeToJSONTyped,
} from './ResetTimingMode';
import type { LeaderboardPeriodType } from './LeaderboardPeriodType';
import {
    LeaderboardPeriodTypeFromJSON,
    LeaderboardPeriodTypeFromJSONTyped,
    LeaderboardPeriodTypeToJSON,
    LeaderboardPeriodTypeToJSONTyped,
} from './LeaderboardPeriodType';
import type { CustomRecurrenceRuleResponse } from './CustomRecurrenceRuleResponse';
import {
    CustomRecurrenceRuleResponseFromJSON,
    CustomRecurrenceRuleResponseFromJSONTyped,
    CustomRecurrenceRuleResponseToJSON,
    CustomRecurrenceRuleResponseToJSONTyped,
} from './CustomRecurrenceRuleResponse';

/**
 * 
 * @export
 * @interface LeaderboardTimeConfigResponse
 */
export interface LeaderboardTimeConfigResponse {
    /**
     * 
     * @type {LeaderboardPeriodType}
     * @memberof LeaderboardTimeConfigResponse
     */
    periodType: LeaderboardPeriodType;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardTimeConfigResponse
     */
    startAt: number;
    /**
     * Optional - recurring leaderboards may run indefinitely
     * @type {number}
     * @memberof LeaderboardTimeConfigResponse
     */
    endAt?: number;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardTimeConfigResponse
     */
    timezone?: string;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardTimeConfigResponse
     */
    currentPeriodNumber: number;
    /**
     * 
     * @type {ResetTimingMode}
     * @memberof LeaderboardTimeConfigResponse
     */
    resetTimingMode: ResetTimingMode;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardTimeConfigResponse
     */
    calendarResetTime?: string;
    /**
     * 
     * @type {CustomRecurrenceRuleResponse}
     * @memberof LeaderboardTimeConfigResponse
     */
    customRecurrenceRule?: CustomRecurrenceRuleResponse;
    /**
     * 
     * @type {CustomRecurrenceRuleResponse}
     * @memberof LeaderboardTimeConfigResponse
     */
    effectiveRecurrence?: CustomRecurrenceRuleResponse;
    /**
     * Anchor for derive-on-read period calculation. During the transition period, `startAt`/`endAt` remain the authoritative period window; once the read-path migration completes, this becomes the sole input to `getCurrentPeriod(lb, now)` for recurring leaderboards. Set server-side at LB creation (and on update via `startAt` translation for recurring LBs in DRAFT/SCHEDULED state). Not directly admin-submittable — clients should keep submitting `startAt` as today. Immutable once the LB is ACTIVE.
     * @type {number}
     * @memberof LeaderboardTimeConfigResponse
     */
    firstPeriodAnchor?: number;
    /**
     * 
     * @type {LeaderboardEndIntent}
     * @memberof LeaderboardTimeConfigResponse
     */
    endIntent?: LeaderboardEndIntent;
    /**
     * Target end date (unix ms) for endIntent=ON_DATE. Board completes at the first period close on or after this timestamp. Ignored unless endIntent is ON_DATE.
     * @type {number}
     * @memberof LeaderboardTimeConfigResponse
     */
    scheduledEndAt?: number;
    /**
     * Opt-in registration window for PAID boards: entry (/join) opens this many minutes before each period's scoring start and closes at start. Unset = legacy behaviour (join allowed any time the board is ACTIVE). Free boards ignore this (auto-enroll on first scoring event).
     * @type {number}
     * @memberof LeaderboardTimeConfigResponse
     */
    registrationLeadMinutes?: number;
}



/**
 * Check if a given object implements the LeaderboardTimeConfigResponse interface.
 */
export function instanceOfLeaderboardTimeConfigResponse(value: object): value is LeaderboardTimeConfigResponse {
    if (!('periodType' in value) || value['periodType'] === undefined) return false;
    if (!('startAt' in value) || value['startAt'] === undefined) return false;
    if (!('currentPeriodNumber' in value) || value['currentPeriodNumber'] === undefined) return false;
    if (!('resetTimingMode' in value) || value['resetTimingMode'] === undefined) return false;
    return true;
}

export function LeaderboardTimeConfigResponseFromJSON(json: any): LeaderboardTimeConfigResponse {
    return LeaderboardTimeConfigResponseFromJSONTyped(json, false);
}

export function LeaderboardTimeConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardTimeConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'periodType': LeaderboardPeriodTypeFromJSON(json['periodType']),
        'startAt': json['startAt'],
        'endAt': json['endAt'] == null ? undefined : json['endAt'],
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
        'currentPeriodNumber': json['currentPeriodNumber'],
        'resetTimingMode': ResetTimingModeFromJSON(json['resetTimingMode']),
        'calendarResetTime': json['calendarResetTime'] == null ? undefined : json['calendarResetTime'],
        'customRecurrenceRule': json['customRecurrenceRule'] == null ? undefined : CustomRecurrenceRuleResponseFromJSON(json['customRecurrenceRule']),
        'effectiveRecurrence': json['effectiveRecurrence'] == null ? undefined : CustomRecurrenceRuleResponseFromJSON(json['effectiveRecurrence']),
        'firstPeriodAnchor': json['firstPeriodAnchor'] == null ? undefined : json['firstPeriodAnchor'],
        'endIntent': json['endIntent'] == null ? undefined : LeaderboardEndIntentFromJSON(json['endIntent']),
        'scheduledEndAt': json['scheduledEndAt'] == null ? undefined : json['scheduledEndAt'],
        'registrationLeadMinutes': json['registrationLeadMinutes'] == null ? undefined : json['registrationLeadMinutes'],
    };
}

export function LeaderboardTimeConfigResponseToJSON(json: any): LeaderboardTimeConfigResponse {
    return LeaderboardTimeConfigResponseToJSONTyped(json, false);
}

export function LeaderboardTimeConfigResponseToJSONTyped(value?: LeaderboardTimeConfigResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'periodType': LeaderboardPeriodTypeToJSON(value['periodType']),
        'startAt': value['startAt'],
        'endAt': value['endAt'],
        'timezone': value['timezone'],
        'currentPeriodNumber': value['currentPeriodNumber'],
        'resetTimingMode': ResetTimingModeToJSON(value['resetTimingMode']),
        'calendarResetTime': value['calendarResetTime'],
        'customRecurrenceRule': CustomRecurrenceRuleResponseToJSON(value['customRecurrenceRule']),
        'effectiveRecurrence': CustomRecurrenceRuleResponseToJSON(value['effectiveRecurrence']),
        'firstPeriodAnchor': value['firstPeriodAnchor'],
        'endIntent': LeaderboardEndIntentToJSON(value['endIntent']),
        'scheduledEndAt': value['scheduledEndAt'],
        'registrationLeadMinutes': value['registrationLeadMinutes'],
    };
}

